import * as React from 'react';
import { ContainerEmailPreview } from './ContainerEmailPreview';

interface FollowUpRequiredPreviewI {
	caseName: string;
	userName?: string;
	questionsList: string[];
	documentsList: string[];
}

export const FollowUpRequiredPreview: React.FC<FollowUpRequiredPreviewI> = ({
	caseName,
	userName = `[User's Name]`,
	questionsList,
	documentsList,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	React.useEffect(() => {
		const fetchHtml = async () => {
			// Get the content of the HTML file
			const response = await fetch(
				'/email-templates/client/follow-up-required-additional.html'
			);
			const html = await response.text();

			// Create a DOM to render the content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Extraer el div con id="principalContent"
			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				// Replace [Case Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Case Name]',
					caseName
				);

				// Replace [User's Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					`[User's Name]`,
					userName
				);

				// Manejar la lista de documentos
				const documentationTitle = Array.from(
					contentElement.querySelectorAll('span')
				).find((el) =>
					el.textContent?.includes('Additional Documentation Required:')
				);

				const customizableList = Array.from(
					contentElement.querySelectorAll('ul')
				).find((ul) =>
					Array.from(ul.querySelectorAll('li')).some(
						(li) => li.textContent === '[Customizable]'
					)
				);

				if (customizableList) {
					customizableList.innerHTML = ''; // Limpiar contenido actual
					if (documentsList.length > 0) {
						documentsList.forEach((doc) => {
							const newItem = document.createElement('li');
							newItem.textContent = doc;
							customizableList.appendChild(newItem);
						});
						const lineBreak = document.createElement('br'); // add linebreak
						customizableList.appendChild(lineBreak);
						// Agregar un salto de línea después del título
						if (documentationTitle) {
							// Agregar saltos de línea
							const lineBreak1 = document.createElement('br'); // add linebreak
							const lineBreak2 = document.createElement('br'); // add linebreak
							documentationTitle.parentNode?.insertBefore(
								lineBreak1,
								documentationTitle.nextSibling
							);
							documentationTitle.parentNode?.insertBefore(
								lineBreak2,
								lineBreak1.nextSibling
							);
						}
					} else if (documentationTitle) {
						// Ocultar el título si no hay documentos
						documentationTitle.remove();
					}
				}

				// Manejar la lista de preguntas
				const clarificationTitle = Array.from(
					contentElement.querySelectorAll('span')
				).find((el) =>
					el.textContent?.includes('Additional Clarifications Required:')
				);

				const customizableList2 = Array.from(
					contentElement.querySelectorAll('ul')
				).find((ul) =>
					Array.from(ul.querySelectorAll('li')).some(
						(li) => li.textContent === '[Customizable2]'
					)
				);

				if (customizableList2) {
					customizableList2.innerHTML = ''; // Limpiar contenido actual
					if (questionsList.length > 0) {
						questionsList.forEach((question) => {
							const newItem = document.createElement('li');
							newItem.textContent = question;
							customizableList2.appendChild(newItem);
						});
					} else if (clarificationTitle) {
						// Ocultar el título si no hay preguntas
						clarificationTitle.remove();
					}
				}

				// Deshabilitar todos los enlaces <a> y aplicar estilos
				const links = doc.querySelectorAll('a');
				links.forEach((link) => {
					link.removeAttribute('href');
					link.style.opacity = '0.7';
					link.style.pointerEvents = 'none';
					link.style.cursor = 'not-allowed';
				});
			}
			setHtmlContent(contentElement?.outerHTML || '');

			// Extract styles from file
			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			{/* Inject the extracted styles and add flex so it looks good in preview */}
			<style>
				{`
					${stylesContent}
					.centerAlign {
						text-align: center;
						margin: 0 auto 0 auto;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				`}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
